import {
	EventType,
	IBaseListAction,
	IChatEventPostbackMessage,
	IChatMessagesOut,
	IChatTextMessage,
	ILinkAction,
	MessageType,
} from '@enuan/chat__utils';
import { useLogError } from '../ErrorBoundary/useLogError';
import { useSendMessage } from '../../hooks/core/messages.hooks';
import { useCallback } from 'react';

export const useOnAction = (command_id: string) => {
	const sendMessage = useSendMessage();
	const logError = useLogError('onAction', { command_id });
	const onAction = useCallback(
		(action: IBaseListAction) => {
			if (action.link) {
				const { url, target } =
					typeof action.link === 'string'
						? ({ url: action.link, target: 'new' } as ILinkAction)
						: action.link;
				const _target = target === 'new' ? '_blank' : '_self';
				window.open(url, _target);
			}

			if (action.postback) {
				const event: IChatMessagesOut<IChatEventPostbackMessage> = {
					_type: MessageType.EVENT,
					_data: {
						name: EventType.POSTBACK,
						parameters: {
							payload: action.postback,
							metadata: { command_id: command_id },
						},
					},
				};
				sendMessage(event, true).catch((error) =>
					logError('postback', { error, payload: { event } })
				);
			}

			if (action.message) {
				const message: IChatMessagesOut<IChatTextMessage> = {
					_type: MessageType.TEXT,
					_data: action.message,
				};
				sendMessage(message).catch((error) =>
					logError('message', { error, payload: { message } })
				);
			}
		},
		[sendMessage, command_id, logError]
	);

	return onAction;
};
